import { SafeHtml } from '@angular/platform-browser';
import { BaseDataTransferObject } from '../../../shared/models/base-data-transfer-object';
import { TestType } from '../../../shared/models/order-entry/test';

export class OrderSearchResult {
    public orderId?: number;
    public testId?: number;
    public results?: string;
    public flag?: string;
    public specialResult?: string;
    public reportAs?: string;
}

export enum ResultType {
    ValueValue = 1,
    GreaterEqualValue = 2,
    LessEqualValue = 4,
    GreaterThanValue = 8,
    LessThanValue = 16, // 0x00000010
    AlphaResults = 32, // 0x00000020
    Microbiology = 64, // 0x00000040
    AlphaMicrobiology = 128, // 0x00000080
    OpenResultWithoutUnit = 256, // 0x00000100
    OpenResultWithUnit = 512, // 0x00000200
    SpecificCutOff = 1024, // 0x00000400
    Titer = 2048, // 0x00000800
    None = 4096, // 0x00001000
}

export enum TestStatus {
    Pending = 1,
    Preliminary = 2,
    Unreleased = 4,
    None = 8,
    Final = 16, // 0x00000010
    Canceled = 32, // 0x00000020
    NA = 0x00000021
}

export class ResultBase extends BaseDataTransferObject {
    public code?: string;
    public name?: string;
    public order?: number;
    public key?: number;
    public parentKey?: number;
}

export class Result extends ResultBase {
    public parentId?: number;
    public level?: number;
    public testGroupId?: number;
    public canceled?: boolean;
    public resultType?: ResultType;
    public testType?: TestType;
    public result?: string;
}

export class ClinicalResult extends Result {
    public flag?: string;
    public unit?: string;
    public referenceRange?: string;
    public comment?: string;
    public resultReportComments?: string;
    public clinicalRangeComment?: string;
    public released?: string;
    public testCancelled?: string;
    public isAbnormal?: boolean;
}

export class ToxicologyResult extends Result {
    public detectionWindow?: string;
    public flag?: string;
    public unit?: string;
    public referenceRange?: string;
    public comment?: string;
    public resultReportComments?: string;
    public clinicalRangeComment?: string;
    public released?: boolean;
    public testCancelled?: string;
    public isAbnormal?: string;
    public cutOff?: string;
    public rxVerification?: string;
}

export class MedicationResult extends Result {
    public medicationId?: number;
    public medicationName?: string;
    public detectionWindow?: string;
}

export enum PathologyReportStatus {
    Normal,
    NormalRelease,
    Addendum,
    AddendumRelease,
    Reviced,
    RevicedRelease
}

export class Pathology {
    public order?: number;
    public title?: string;
    public comment?: string | SafeHtml;
    public status?: PathologyReportStatus;
}

export class PathologyResult extends ResultBase {
    public status?: TestStatus;
    public results?: Pathology[];
}

export class Sensitivity {
    public mic?: string;
    public microbiologyInterpretationType?: string;
    public antibioticName?: string;
    public comment?: string;
    public microbiologyInterpretationTypeShort?: string;
}

export class Organism {
    public name?: string;
    public cultureQuantityName?: string;
    public comment?: string;
    public organismComment?: string;
    public haveSensitivity?: boolean;
    public sensitivity?: Sensitivity[];
}

export class Source {
    public name?: string;
    public cultureQuantityName?: string;
}

export class MicrobiologyResult extends Result {
    public collected?: Date;
    public status?: TestStatus;
    public flag?: string;
    public microbiologyFlag?: string;
    public unit?: string;
    public referenceRange?: string;
    public comment?: string;
    public clinicalRangeComment?: string;
    public preliminaryResultComment?: string;
    public collectionSite?: string;
    public released?: boolean;
    public testCancelled?: boolean;
    public findings?: Source[];
    public organisms?: Organism[];
    public sources?: string;
}
